import React from "react";
import { AUTO_PHONE_DISPLAY, CS_PHONE_DISPLAY } from "@/brand";

/* Feb 2026 — Damage Protection Plan is deprecated in favor of Enchanted
 * Care + Enchanted Peace of Mind. Old imports of `ConsentSection` still
 * point here (SMS + Terms checkboxes), so we keep that export intact.
 *
 * June 2026 — SMS consent is now OPTIONAL (TCPA: consent is not a condition
 * of purchase). Only the Terms checkbox remains required.
 */
export const ConsentSection = ({ smsOptedIn, setSmsOptedIn, termsAccepted, setTermsAccepted, onOpenTerms }) => (
  <div className="glass p-5 sm:p-6 space-y-4 text-sm text-[#F6F1E4]" data-testid="booking-consent">
    <div>
      <label className="flex items-start gap-3 cursor-pointer" data-testid="sms-checkbox-wrap">
        <input type="checkbox" checked={smsOptedIn} onChange={(e) => setSmsOptedIn(e.target.checked)} className="mt-1 w-5 h-5 accent-[#FFD166]" data-testid="sms-checkbox" />
        <span>
          <strong className="text-[#FFD166]">SMS Updates</strong>{" "}
          <span className="text-emerald-300">(Recommended for the easiest handoff)</span> — By providing your mobile
          number and opting in to SMS, you agree to receive transactional text messages from Enchanted Gear Rentals
          regarding your reservation, including order confirmations, reminders, delivery/pickup updates, and other
          order-related information. Automated order updates may come from <strong className="text-[#F6F1E4]">{AUTO_PHONE_DISPLAY}</strong>.
          For customer service, call or text <strong className="text-[#F6F1E4]">{CS_PHONE_DISPLAY}</strong>. Message and
          data rates may apply. Reply STOP to opt out. Consent is not a condition of purchase.
        </span>
      </label>
      <p className="mt-2 pl-8 text-xs text-[#B9C8D5] leading-relaxed" data-testid="sms-consent-notice">
        SMS is our preferred communication method because it allows the fastest and easiest delivery and pickup
        coordination. If you choose not to receive SMS updates, we may attempt to contact you by email. You are still
        responsible for being present in your resort lobby for the entire selected delivery and pickup window. If we are
        unable to reach you and you are not present when our driver arrives, a waiting or rescheduling fee may apply, or
        your reservation may be cancelled without refund in accordance with our Terms &amp; Conditions.
      </p>
    </div>
    <label className="flex items-start gap-3 cursor-pointer" data-testid="terms-checkbox-wrap">
      <input type="checkbox" required checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} className="mt-1 w-5 h-5 accent-[#FFD166]" data-testid="terms-checkbox" />
      <span>
        <strong className="text-[#FFD166]">Terms &amp; Cancellation Policy</strong> — I have read and
        accept the{" "}
        <button type="button" onClick={onOpenTerms} className="underline text-[#FFD166] hover:text-[#F4A93A]" data-testid="terms-open-modal">
          Terms and Conditions
        </button>
        , including how Enchanted Care and Enchanted Peace of Mind work, and the{" "}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="underline text-[#FFD166] hover:text-[#F4A93A]" data-testid="privacy-policy-link">
          Privacy Policy
        </a>
        . <span className="text-[#F4A93A]">*</span>
      </span>
    </label>
  </div>
);
